export default {
    resultadoBuscaTodosServicosOrcamento: {
        filtros: {
            orcamentoId: {
                default: null,
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'dataCadastro',
            direction: 'ASC',
        }
    },
}